// removed by extract-text-webpack-plugin
module.exports = {"component":"_1B7mszjR9WIsydHc25bRnq","img":"_116Yw_eNPD5Lj93skcF-l7","txt":"_2B_Cat4KhvzQwL6e71BpyN"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalCenterBecomePartner/PersonalCenterBecomePartner.scss
 ** module id = 1086
 ** module chunks = 0
 **/